import { Reducer } from 'redux';

import { LeadershipActivityForNetworkLoadAction } from '../../domains/leadershipActivityForNetwork/actions.types';

import { LeadershipActivityForNetworkLifecycle } from './types';

const initialState: LeadershipActivityForNetworkLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<LeadershipActivityForNetworkLifecycle, LeadershipActivityForNetworkLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'LEADERSHIP_ACTIVITY_FOR_NETWORK.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'LEADERSHIP_ACTIVITY_FOR_NETWORK.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.leadershipActivityForNetwork };
    case 'LEADERSHIP_ACTIVITY_FOR_NETWORK.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
